var uploadData = {
  name: 'upload',
  data: [{
    listNameColor: '#3889FF',
    listErrorColor: '#FF5656',
    cardListTextMarginTop: '0.3rem',
    listProgressBGColor: '#1E87F0',
    dragIconColor: '#3889FF'
  }]
};
export default uploadData;